import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { AttachmentModel }    from './models/attachment';
import { AttachmentsService } from './attachments.service';

@Component({
  selector   : 'wor-email-attachments',
  template: require('./attachments.email.component.html')
})
export class EmailAttachmentsComponent implements DoCheck {
  @Input() attachments: Array<AttachmentModel> = [];
  @Output() selectedChange = new EventEmitter<Array<string>>();

  selected: Array<string> = [];
  private lastCount = -1;

  constructor (private attachmentsService: AttachmentsService) {}

  ngDoCheck (): void {
    const sel = this.attachments?.filter(a => a.selected).map(a => a.id) || [];
    if (sel.length !== this.lastCount) {

      this.selected = sel;
      this.lastCount = sel.length;
      this.selectedChange.emit(this.selected);

    }
  }

  isPdf(attachment: AttachmentModel): boolean {


    return this.attachmentsService.isPdf(attachment);


  }

  select(attachment: AttachmentModel): void {


    attachment.selected = !attachment.selected;


  }

  selectAll (): void {


    const allSelected = this.selected.length === this.attachments.length;


    this.attachments.forEach(a => { a.selected = !allSelected;


    });


  }
}
